import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import HomePage from '../view/HomePage'
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes: [{
    path: "/",
    component: HomePage
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  },
  {
    name: "AdminLogin",
    path: '/im_admin/login',
    component: () => import("../view/admin/AdminLogin")
  },
  {
    name: "Admin",
    path: '/im_admin',
    component: () => import("../view/admin/AdminIndex"),
    redirect: '/im_admin/user',
    children: [
      {
        name: "UserManagement",
        path: "/im_admin/user",
        component: () => import("../view/admin/UserManagement")
      },
      {
        name: "InvitationManagement",
        path: "/im_admin/invitation",
        component: () => import("../view/admin/InvitationManagement")
      },
      {
        name: "GroupManagement",
        path: "/im_admin/group",
        component: () => import("../view/admin/GroupManagement")
      },
      {
        name: "SystemManagement",
        path: "/im_admin/system",
        component: () => import("../view/admin/SystemManagement")
      },
      {
        name: "PasswordChange",
        path: "/im_admin/password",
        component: () => import("../view/admin/PasswordChange")
      },
      {
        name: "LogsManagement",
        path: "/im_admin/logs",
        component: () => import("../view/admin/LogsManagement")
      },
      {
        name: "StatsDashboard",
        path: "/im_admin/stats",
        component: () => import("../view/admin/StatsDashboard")
      }
    ]
  }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/im_admin') && !to.path.startsWith('/im_admin/login')) {
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      next('/im_admin/login');
      return;
    }
  }
  next();
});

export default router;